export default __webpack_public_path__ + "static/media/018-flash drive.4a34b1b3.svg";